import React from 'react'
import { browserHistory } from 'react-router'
import * as MabnaButton from '../common/Button/Button'

export default () => {
  return (
    <div id="signup-success">
      <div
        className="text-center bg-darkblue fg-white"
        style={{ flex: 1, marginBottom: 10 }}
      >
        <h4 style={{ margin: 0, padding: 10 }}>عضویت</h4>
      </div>

      <div>
        <i
          className="fa fa-check-circle-o fa-3x"
          aria-hidden="true"
          style={{ color: 'green' }}
        />
      </div>

      <div style={{ direction: 'rtl' }}>
        <h4>عضویت شما در سامانه با موفقیت انجام شد.</h4>
        <h4>برای ثبت نام و شرکت در برنامه های آموزشی به سامانه مبنا وارد شوید.</h4>
      </div>

      <hr />

      <div style={{ marginBottom: 30 }}>
        <MabnaButton.Primary buttonSize={MabnaButton.SIZES.LARGE} onClick={() => browserHistory.push('/')}>
          ورود به سامانه
        </MabnaButton.Primary>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/authentication/SignupSuccess.js